import axios from "axios";
import { request } from "@/utils/request";
import store from "@/store";



/**
 * 登录
 * @param {*} phoneNumber
 * @param {*} verCode
 * @returns
 */
export async function loginNew(data) {
  const resp = await request({
    url: `/sys/login`,
    method: "POST",
    data
  });
  if (resp.code === 200) {
    console.log(resp);
    console.log(resp.data);
  }
  return resp;
}


/**
 * 登录
 * @param {*} phoneNumber
 * @param {*} verCode
 * @returns
 */
export async function login(data) {
  const resp = await request({
    // url: "/admin/mall/sup/login",
    url: `/administrator/login`,
    method: "POST",
    // 明文登录：关闭加解密
    isEncrypt: false,
    isDecrypt: false,
    data
  });
  // var token = resp.headers.authorization;
  // var storeToken = resp.data.data;
  // 拿到服务器的令牌authorization
  // if (storeToken) {
  //   localStorage.setItem("storeToken", JSON.stringify(storeToken));
  // }
  if (resp.code === 200) {
    // 模拟生成token
    localStorage.setItem("storeToken", resp.data);
    // this.$store.commit("updataUserInfo", resp.data);
    // localStorage.setItem("userInfo", JSON.stringify(resp.data));
  }
  return resp;
}


/**
 * 使用保存的令牌从服务器换取登录信息
 * @returns
 */
export async function queryMyselfInfo(data) {
  const storeToken = localStorage.getItem("storeToken");
  return request({
    url: "/sys/user/getUserInfo",
    method: "GET",
  });
}

/* 注销登录 */
export function loginOut(data) {
  const resp = request({
    url: "/sys/logout",
    method: "POST",
    data,
  });
  localStorage.removeItem("storeToken"); //用户token
  localStorage.removeItem("loginTenantId"); //租户ID
  store.commit("updataUserInfo", {}); //清除仓库信息
  store.commit("updataFilterNavList", []); //清除菜单信息
  store.commit("updataFilterStoreList", []); //清除门店权信息
  return resp;
}

/**
 * 发送验证码
 * @phoneNumber
 */
// export async function selectProductData(params) {
//   var resp = await axios.get(`/phoneSelectProductInfo/public/asr/sendCode`, {
//     params,
//   });
//   return resp;
// }

/**
 * 发送短信验证码(找回密码专用)
 * @param {*} data { mobile: 手机号, smsmode: 2 }
 */
export async function sendSmsCode(data) {
  return request({
    url: '/sys/sms',
    method: 'POST',
    data
  });
}